/**
 * Выбор изображения / файла для WebView (тот же механизм, что в UploadButton
 * freedom-cabinet): нативный системный пикер через input[type=file].
 * capture=environment — камера, без capture — галерея / документы.
 */
export const DOCUMENT_MEDIA_ACCEPT = {
  image: 'image/jpeg,image/png,image/webp,image/heic,image/*',
  imageAndPdf:
    'image/jpeg,image/png,image/webp,image/heic,image/*,application/pdf',
} as const;

export const MAX_DOCUMENT_AUTOFILL_FILES = 2;
